import { useCallback, useMemo, useState } from "react";

function useStayAndLeaveHandlers() {
  const [stayHandler, setStayHandlerDispatch] = useState<(() => void) | null>(
    null
  );
  const [leaveHandler, setLeaveHandlerDispatch] = useState<(() => void) | null>(
    null
  );

  const setStayHandler = useCallback((newStayHandler: (() => void) | null) => {
    setStayHandlerDispatch((prev) => {
      if (newStayHandler !== null && prev !== null) {
        throw new Error("Another stay handler is already set");
      }
      return newStayHandler;
    });
  }, []);

  const setLeaveHandler = useCallback(
    (newLeaveHandler: (() => void) | null) => {
      setLeaveHandlerDispatch((prev) => {
        if (newLeaveHandler !== null && prev !== null) {
          throw new Error("Another leave handler is already set");
        }
        return newLeaveHandler;
      });
    },
    []
  );

  return useMemo(() => {
    return {
      stayHandler,
      setStayHandler,
      leaveHandler,
      setLeaveHandler,
    };
  }, [leaveHandler, setLeaveHandler, setStayHandler, stayHandler]);
}

export default useStayAndLeaveHandlers;
